function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports;
  if (!is_node) ;else ;
  define(['/util/date.js', '/util/country.js', '/util/util.js'], (date, zcountry, zutil) => {
    var E = {
      t: {}
    };
    var ms = date.ms;
    E.desktop_gateways = ['paypal', 'paymill', 'avangate', 'bluesnap', 'paypal2', 'coupon', 'stripe', 'adyen'];
    E.mobile_gateways = ['android', 'apple'];
    E.gateways = E.desktop_gateways.concat(E.mobile_gateways);

    // extra days for a case when automatic payment comes lately
    E.grace = 1;

    // list of periods that we have or had
    E.periods = ['1 D', '1 W', '1 M', '3 M', '6 M', '1 Y', '2 Y', '3 Y'];
    E.period_unit_to_ms = {
      D: ms.DAY,
      W: 7 * ms.DAY,
      M: ms.MONTH,
      Y: ms.YEAR
    };
    E.period_unit_names = {
      D: 'day',
      W: 'week',
      M: 'month',
      Y: 'year'
    };
    E.type2name = {
      plus: 'premium',
      ultra: 'ultra'
    };
    E.get_country_code = membership => {
      if (!membership) return;
      var country_name = membership.geo_country || membership.country;
      return zcountry.mixed2code(country_name) || country_name;
    };
    E.get_gateways = type => {
      if (!type) return [];
      switch (type) {
        case 'desktop':
          return E.desktop_gateways;
        case 'mobile':
          return E.mobile_gateways;
        case 'paypal':
          return ['paypal', 'paypal2'];
      }
      return E.gateways.includes(type) ? [type] : [];
    };
    E.get_period_ms = period => {
      var _ref = E.parse_period(period) || {},
        count = _ref.count,
        unit = _ref.unit;
      return count * E.period_unit_to_ms[unit];
    };
    E.get_offsets = d => {
      var offsets = {};
      var _iterator = _createForOfIteratorHelper(E.periods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          offsets[p] = E.offset_by_period(d, p, -1);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return offsets;
    };
    E.offset_by_period = (d, period, factor = 1) => {
      d = date(d, true);
      var _ref2 = E.parse_period(period) || {},
        count = _ref2.count,
        unit = _ref2.unit;
      switch (unit) {
        case 'D':
          d.setUTCDate(d.getUTCDate() + count * factor);
          return d;
        case 'W':
          d.setUTCDate(d.getUTCDate() + 7 * count * factor);
          return d;
        case 'M':
          {
            var day = d.getUTCDate();
            d.setUTCMonth(d.getUTCMonth() + count * factor);
            // fix for 31-Jan to be 28-Feb
            if (d.getUTCDate() != day) d.setUTCDate(0);
            return d;
          }
        case 'Y':
          d.setUTCFullYear(d.getUTCFullYear() + count * factor);
          return d;
      }
    };
    var get_end_by_period = (m, opt) => {
      opt = opt || {};
      var test_iap = m.test && is_app_store_iap(m);
      var end = m.period && !test_iap ? E.offset_by_period(opt.start || m.start, m.period) : m.end || m.trial_end || m.grace_end;
      if (!end) {
        throw new Error('Unexpected period: ' + m.period + ' (' + JSON.stringify(m) + ')');
      }
      end = date(end);
      if (!opt.disable_grace) {
        if (test_iap) end.setUTCMinutes(end.getUTCMinutes() + E.grace);else end.setUTCDate(end.getUTCDate() + E.grace);
      }
      return end;
    };
    E.get_length_by_period = period => {
      var start = Date.now();
      return get_end_by_period({
        period
      }, {
        start
      }) - start;
    };
    E.get_dur = m => get_end_by_period(m, {
      disable_grace: true
    }) - date(m.start);
    E.get_end_by_period = get_end_by_period;
    E.get_end_date = m => {
      var ends = [];
      if (m && m.trial_end) ends.push(date(m.trial_end));
      if (m && m.grace_end) ends.push(date(m.grace_end));
      if (m && m.end) ends.push(date(m.end));
      if (m && m.start && m.period && (!m.cancelled || !m.end) && !E.is_trial(m)) {
        var _end = get_end_by_period(m);
        if (_end) ends.push(_end);
      }
      if (!ends.length) return null;
      var res = date(Math.max.apply(null, ends));
      return res;
    };
    E.is_active = (m, _now) => {
      var now = _now || Date.now();
      if (!m) return false;
      if (m.trial_end && now <= date(m.trial_end)) return true;
      if (m.grace_end && now <= date(m.grace_end)) return true;
      if (m.end && now <= date(m.end)) return true;
      if (m.start && m.period && now <= get_end_by_period(m) && !E.is_trial(m)) return !m.cancelled || !m.end;
      return false;
    };
    E.is_ultra = m => E.is_active(m) && m && m.type == 'ultra';
    E.is_lifetime = m => m && m.period == '100 Y';
    E.is_in_trial = m => E.is_trial(m) && Date.now() < date(m.trial_end || m.end);
    E.is_trial = (m, type) => !!(m && (m.trial_end && (!type || type == (m.type || 'start')) || m.plan == 'trial' && m.end));
    E.is_in_grace = m => E.is_grace(m) && Date.now() < date(m.grace_end);
    E.is_grace = (m, type) => !!m && !!m.grace_end && (!type || type == (m.type || 'start'));
    E.is_manual = m => !!m && m.plan == 'manual';
    E.had_premium = history => !!history && history.some(m => !E.is_trial(m));
    E.had_trial = (history, type) => !!history && history.some(h => E.is_trial(h, type));
    E.had_grace = (history, type) => !!history && history.some(h => E.is_grace(h, type));
    E.trial_forbidden = (m, history, type) => {
      if (E.is_in_trial(m)) return 'trial exists';
      if (E.is_trial(m, type)) return 'trial expired';
      if (E.is_active(m)) return 'already premium';
      if (E.had_premium(history)) return 'had premium';
      if (E.had_trial(history, type)) return 'had trial';
      return false;
    };
    E.grace_period_forbidden = (m, history, type) => {
      if (E.is_in_grace(m)) return 'grace exists';
      if (E.is_grace(m, type)) return 'grace expired';
      if (E.is_active(m)) return 'already premium';
      if (E.had_grace(history, type)) return 'had grace';
      return false;
    };
    E.is_paid = m => !!m && !!m.gateway;
    E.is_paid_amount = m => E.is_paid(m) && (m.amount || m.amount_usd);
    E.is_expired = m => {
      var end_date = E.get_end_date(m);
      return !!end_date && Date.now() > end_date;
    };
    E.classify = m => {
      if (E.is_active(m)) return E.is_in_trial(m) ? 'trial' : 'premium';
      if (E.is_expired(m)) return E.is_trial(m) ? 'trial_expired' : 'premium_expired';
      return 'free';
    };
    E.gen_email_hash = (email, md5) => md5('hola unsubscribe ' + email).substr(0, 8);
    E.fmt_date = (d, fmt) => d ? date.strftime(fmt || '%o %B %Y', date(d)) : '-';

    // gateway does not exist in ios trial
    E.is_ios = m => m.gateway == 'apple' || m.product == 'ios';
    E.is_mobile = m => E.is_ios(m) || !!m.gateway && !E.desktop_gateways.includes(m.gateway);
    E.is_desktop = m => E.desktop_gateways.includes(m.gateway);
    E.get_plan_short_name = period => {
      var _ref3 = E.parse_period(period) || {},
        count = _ref3.count,
        unit = _ref3.unit;
      var period_name = E.period_unit_names[unit];
      var short_name = {
        '1 D': 'Daily',
        '1 W': 'Weekly',
        '1 M': 'Monthly',
        '1 Y': 'Yearly'
      }[period];
      if (!short_name) {
        short_name = count + ' ' + period_name[0].toUpperCase() + period_name.substr(1);
        if (count > 1) short_name += 's';
      }
      return short_name;
    };
    E.get_period_with_price = m => {
      if (m.plan == 'signup_bonus') return 'Signup bonus';
      if (m.period == '100 Y') return 'Lifetime';
      var _ref4 = E.parse_period(m.period) || {},
        count = _ref4.count,
        unit = _ref4.unit;
      if (m.gateway == 'coupon' && count) return count + '-' + E.period_unit_names[unit];
      var end = E.get_end_date(m);
      if (m.cancelled) return 'Till ' + E.fmt_date(end);
      var show_price = name => {
        if (!m.amount) return name;
        var price = m.amount;
        var currency = m.currency;
        var vat = m.vat;
        var p = +(price / count).toFixed(2);
        var price_string = zcountry.format_price(currency, p);
        return name + ', ' + price_string + '/' + E.period_unit_names[unit] + (vat && vat.percent ? ' (includes VAT ' + vat.percent + '% ' + zcountry.format_price(currency, vat.amount) + ')' : '');
      };
      switch (unit) {
        case 'W':
          if (count == 1) return show_price('Weekly');
          return show_price(count + '-week');
        case 'M':
          if (count == 1) return show_price('Monthly');
          if (count == 6) return show_price('Half-yearly');
          return show_price(count + '-month');
        case 'Y':
          if (count == 1) return show_price('Yearly');
          return show_price(count + '-year');
        case 'D':
          return show_price(count + '-day');
      }
      if (!m.end) return m.grace_end ? 'updating' : '-';
      return (m.gateway ? 'Till ' : 'Manual till ') + E.fmt_date(end);
    };
    E.get_per = (period, full) => {
      var _ref5 = E.parse_period(period) || {},
        count = _ref5.count,
        unit = _ref5.unit;
      var name = E.period_unit_names[unit];
      return count == 1 ? (full ? count + ' ' : '') + name : count + ' ' + name + 's';
    };
    E.sum_period = (p1, p2) => {
      var _ref6 = E.parse_period(p1) || {},
        c1 = _ref6.count,
        u1 = _ref6.unit;
      var _ref7 = E.parse_period(p2) || {},
        c2 = _ref7.count,
        u2 = _ref7.unit;
      if (u1 == u2) return `${c1 + c2} ${u1}`;
      var c_min, c_max, u_min, u_max;
      var ums = E.period_unit_to_ms;
      if (ums[u1] > ums[u2]) {
        c_max = c1;
        u_max = u1;
        c_min = c2;
        u_min = u2;
      } else {
        c_max = c2;
        u_max = u2;
        c_min = c1;
        u_min = u1;
      }
      if (u_min == 'D') return c_min + c_max * ums[u_max] / ums.D + ' D';
      if (u_min == 'W') return c_min * 7 + c_max * ums[u_max] / ums.D + ' D';
      if (u_min == 'M') return c_min + c_max * 12 + ' M';
    };
    E.period_start_str = m => E.fmt_date(m.start);
    E.period_end_str = (m, fmt) => {
      if (E.is_in_trial(m)) return 'Trial valid until ' + E.fmt_date(m.trial_end);
      if (m.next_renewal_date) return E.fmt_date(m.next_renewal_date);
      if (m.cancelled || !m.period) return m.grace_end ? 'updating' : '-';
      return E.fmt_date(m.end || E.offset_by_period(m.start, m.period), fmt);
    };

    // ios app is not associated with App Store until after trial is expired
    E.is_unassoc_trial = m => E.is_trial(m) && E.is_ios(m);
    E.is_bonus = m => m && m.plan == 'signup_bonus';
    E.payment_label = m => {
      if (E.is_unassoc_trial(m) || E.is_bonus(m)) return '-';
      switch (m.gateway) {
        case 'paypal':
        case 'paypal2':
          return 'PayPal';
        case 'coupon':
          return 'Coupon';
        case 'paymill':
          return 'Credit card ************' + (((m.paymill | {}).payment || {}).last4 || '****');
        case 'avangate':
        case 'stripe':
        case 'bluesnap':
          return 'Credit card';
        case 'apple':
          return 'App Store';
        case 'android':
          return 'Google Play';
        default:
          return m.grace_end ? 'updating' : m.plan == 'manual' ? 'Other' : 'Google Play';
      }
    };
    E.gateway_id_path = gateway => {
      switch (gateway) {
        case 'paypal':
        case 'paypal2':
          return 'paypal.subscr_id';
        case 'coupon':
          return 'coupon.code';
        case 'bluesnap':
          return 'bluesnap.subscr_id';
        case 'stripe':
          return 'stripe.subscr_id';
        case 'apple':
          return 'apple_ios.original_transaction_id';
        case 'android':
          return 'google_apk.purchase_token';
        case 'avangate':
          return 'avangate.subscr_ref';
        case 'paymill':
          return 'paymill.subscription_id';
        case 'adyen':
          return 'adyen.subscr_id';
      }
    };
    E.get_paypal_id = m => zutil.get(m, 'paypal.subscr_id') || zutil.get(m, 'paypal2.subscr_id') || zutil.get(m, 'paypal.txn_id');
    E.parse_id = (subscr_id, gateway) => {
      if (gateway == 'bluesnap' && subscr_id) return +subscr_id;
      return subscr_id;
    };
    E.get_id = (m, gateway) => {
      if (!m) return;
      if (m && m.plan == 'manual') return +date(m.start);
      gateway = gateway || m.gateway;
      switch (gateway) {
        case 'paypal':
        case 'paypal2':
          return E.get_paypal_id(m);
        case 'bluesnap_gpay':
        case 'bluesnap_apm':
        case 'bluesnap_applepay':
        case 'bluesnap':
          return m.bluesnap && (m.bluesnap.subscr_id || m.bluesnap.ref);
        case 'apple':
          return zutil.get(m, 'apple_ios.original_transaction_id') || zutil.get(m, 'apple_ios.transaction_id');
        case 'coupon':
        case 'android':
        case 'avangate':
        case 'stripe':
        case 'paymill':
        case 'adyen':
          return zutil.get(m, E.gateway_id_path(gateway));
      }
    };
    E.get_gateway_name = (m, gateway) => {
      gateway = gateway || m && m.gateway;
      switch (gateway) {
        case 'bluesnap':
          if (zutil.get(m, 'bluesnap.gpay')) gateway = 'bluesnap_gpay';else if (zutil.get(m, 'bluesnap.applepay')) gateway = 'bluesnap_applepay';else if (!zutil.get(m, 'bluesnap.subscr_id') && zutil.get(m, 'bluesnap.ref')) {
            gateway = 'bluesnap_apm';
          }
          break;
        case 'paypal':
        case 'paypal2':
          gateway = 'paypal';
          break;
        case 'avangate':
        case 'stripe':
        case 'apple':
        case 'android':
        case 'coupon':
        case 'paymill':
        case 'bluesnap_gpay':
        case 'bluesnap_apm':
        case 'bluesnap_applepay':
        case 'adyen':
          break;
        default:
          if (m && m.plan == 'trial') gateway = 'trial';else if (m && m.plan == 'grace') gateway = 'grace';else if (m && m.plan == 'manual') gateway = 'manual';else gateway = 'unknown';
      }
      return gateway;
    };
    E.get_full_id = (m, gateway, id) => {
      id = id || E.get_id(m);
      if (!id) return;
      return E.get_gateway_name(m, gateway) + '-' + id;
    };
    E.is_cancellable_mobile = m => E.is_mobile(m) && !E.is_unassoc_trial(m) && (m.cancelled || m.cancellation_reason);
    E.is_cancellable = m => !m.cancelled && !E.is_cancellable_mobile(m) && !E.is_unassoc_trial(m) && !m.grace_end && !E.is_bonus(m);
    E.get_plan_currency = (plan, currency) => {
      if (!currency || !plan) return 'USD';
      currency = currency.toUpperCase();
      if (currency == 'USD') return 'USD';
      if (!plan.currency || !plan.currency[currency.toLowerCase()]) return 'USD';
      return currency;
    };
    E.get_price_plan = (plan, currency) => {
      currency = ('' + currency).toLowerCase();
      return currency == 'usd' || !plan.currency || !plan.currency[currency] ? plan : plan.currency[currency];
    };
    E.is_better = (m1, m2) => {
      if (!m1) return false;
      if (!m2) return true;
      if (m1.type == 'ultra' && m2.type != 'ultra') return true;
      if (m2.type == 'ultra' && m1.type != 'ultra') return false;
      if (!m1.period && m1.plan != 'manual' && m2.period) return false;
      if (!m2.period && m2.plan != 'manual' && m1.period) return true;
      var start = Date.now();
      var end1 = get_end_by_period(m1, {
        start,
        disable_grace: true
      });
      var end2 = get_end_by_period(m2, {
        start,
        disable_grace: true
      });
      return end1 > end2;
    };
    E.is_more_actual = (m1, m2) => {
      if (!m1) return false;
      if (!m2) return true;
      if (!m1.period && m1.plan != 'manual') return false;
      if (!m2.period && m2.plan != 'manual') return true;
      var end1 = E.get_end_date(m1);
      var end2 = E.get_end_date(m2);
      return end1 > end2;
    };
    E.find_last = (m, history, subscr_id) => {
      if (m && E.get_id(m) == subscr_id) return {
        m
      };
      if (!Array.isArray(history)) return {};
      for (var i = history.length - 1; i >= 0; i--) {
        if (E.get_id(history[i]) == subscr_id) return {
          m: history[i],
          index: i
        };
      }
      return {};
    };
    var is_app_store_iap = m => {
      return (zutil.get(m, 'apple_ios.bundle_id') || '').startsWith('org.hola.hola');
    };
    E.t.get_exp_date_by_gateway = (m, gateway) => {
      gateway = gateway || m.gateway;
      switch (gateway) {
        // XXX vitaly: sometimes avangate sends outdated expiration_date,
        // so we can't rely on it. Example: google/106641825611906290005
        // case 'avangate': return zutil.get(m, 'avangate.expiration_date');
        case 'bluesnap':
          return zutil.get(m, 'bluesnap.exp_date');
        case 'stripe':
          return zutil.get(m, 'stripe.exp_date');
        case 'android':
          return zutil.get(m, 'google_apk.expiry');
      }
      // XXX mikita: all appstore payments expiry already casted to end
      if (E.is_ios(m)) return is_app_store_iap(m) && m.test ? m.end : undefined;
    };
    var get_seq_id_by_exp = (exp, m) => {
      var period = m.period.split(' ');
      // XXX mikita: sandbox payment periods are drastically reduced to minutes
      if (is_app_store_iap(m) && m.test) return +date.align(exp, 'MIN');
      var align = {
        D: 'DAY',
        W: 'WEEK',
        M: 'MONTH',
        Y: 'YEAR'
      }[period[1]];
      return +date.align(exp, align);
    };
    var get_seq_data = m => {
      if (!m || !m.period) return;
      var exp_date = E.t.get_exp_date_by_gateway(m);
      var exp = date(exp_date || E.offset_by_period(m.start, m.period));
      if (m.end && date(m.end) > exp) exp = date(m.end);
      return {
        seq_id: get_seq_id_by_exp(exp, m),
        exp,
        persistent: m.persistent || !!exp_date
      };
    };
    E.get_seq_id = m => {
      var res = get_seq_data(m);
      return res && res.seq_id;
    };
    E.make_seqs = memberships => {
      var ids = new Set();
      var _iterator2 = _createForOfIteratorHelper(memberships),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var m = _step2.value;
          var id = E.get_id(m);
          if (id) ids.add(id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var res = {};
      var _iterator3 = _createForOfIteratorHelper(ids),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _id = _step3.value;
          res[_id] = E.make_seq(memberships, _id);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return res;
    };
    E.make_seq = (memberships, subscr_id) => {
      var list = [];
      var _iterator4 = _createForOfIteratorHelper(memberships),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _m = _step4.value;
          if (!E.is_paid_amount(_m) || {
            trial: 1,
            grace: 1
          }[_m.plan]) continue;
          if (subscr_id && E.get_id(_m) != subscr_id) continue;
          list.push(_m);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      list.sort((m1, m2) => {
        if (date(m1.start) < date(m2.start)) return -1;
        if (date(m1.start) > date(m2.start)) return 1;
        return 0;
      });
      var seq = [];
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        var start = date(m.start);
        var _ref8 = get_seq_data(m) || {},
          seq_id = _ref8.seq_id,
          exp = _ref8.exp,
          persistent = _ref8.persistent;
        var last = seq[seq.length - 1];
        // skip with same start date
        if (last && !(start - date(last.m.start))) {
          // prefer persistent over not persistent
          if (persistent && !last.persistent) seq[seq.length - 1] = {
            m,
            seq_id,
            exp,
            persistent
          };
          seq[seq.length - 1].duplicate = true;
          continue;
        }
        var end = m.end && date(m.end);
        // skip short membership inside previous membership
        if (last && end && start < end && end < last.exp) {
          last.duplicate = true;
          continue;
        }
        var next_seq_id = last && +E.offset_by_period(last.seq_id, m.period);
        // restore interrupted sequence by shifting last expiration date
        // if sequence is interrupted for no more than one period
        if (next_seq_id && seq_id > next_seq_id && seq_id <= +E.offset_by_period(next_seq_id, m.period)) {
          exp = E.offset_by_period(last.exp, m.period);
          seq_id = next_seq_id;
        }
        if (last && last.seq_id >= seq_id) {
          // skip real duplicates
          if (last.seq_id == seq_id && (!persistent || persistent && last.persistent)) {
            last.duplicate = true;
            continue;
          }
          // restore interrupted sequence by review and shifting all previous
          var new_seq = [{
            m,
            seq_id,
            exp,
            persistent
          }];
          for (var j = seq.length - 1; j >= 0; j--) {
            var item = seq[j];
            if (!item.persistent) {
              item.exp = E.offset_by_period(new_seq[0].exp, m.period, -1);
              item.seq_id = get_seq_id_by_exp(item.exp, m);
            }
            // skip duplicates in new sequence
            if (item.seq_id >= new_seq[0].seq_id || item.exp < date(item.m.start)) {
              // prefer persistent over not persistent
              if (item.persistent) new_seq[0] = item;
              new_seq[0].duplicate = true;
              continue;
            }
            new_seq.unshift(item);
          }
          seq = new_seq;
          continue;
        }
        seq.push({
          m,
          seq_id,
          exp,
          persistent
        });
      }
      return seq;
    };
    var omit_meta = o => !o ? null : zutil.omit(o, ['actual_from', 'actual_to', 'update_res', 'reported', 'amount_usd', 'payment_intent_id', 'is_new', 'pending_emails']);
    E.parse_period = period => {
      var m = ('' + period).match(/^(\d+)\s?([dwmy])$/i);
      if (!m) return;
      return {
        count: +m[1],
        unit: m[2].toUpperCase()
      };
    };
    E.is_duplicate = (m1, m2) => {
      var omitted_m1 = omit_meta(m1);
      var omitted_m2 = omit_meta(m2);
      if (m1 && m2 && Math.abs(m2.start - m1.start < date.ms.DAY)) {
        omitted_m1 = zutil.omit(omitted_m1, ['start']);
        omitted_m2 = zutil.omit(omitted_m2, ['start']);
      }
      if (m1 && m2 && Math.abs(m2.end - m1.end) < date.ms.DAY) {
        omitted_m1 = zutil.omit(omitted_m1, ['end']);
        omitted_m2 = zutil.omit(omitted_m2, ['end']);
      }
      return zutil.equal_deep(omitted_m1, omitted_m2);
    };
    E.get_hola_pro_product_by_subscription = (config, plan_id) => {
      var migration_rule = config.migration_rule ? config.migration_rule[plan_id] : '';
      var prod = config.plans_config[migration_rule || plan_id];
      if (!prod) return null;
      return {
        id: prod.type,
        period: prod.period,
        limit: prod.limit,
        ips_amount: prod.ips_amount,
        quantity: prod.unit == 'ip' ? prod.ips_amount : prod.limit,
        plan_id: plan_id,
        unit: prod.unit || 'gb'
      };
    };
    return E;
  });
})();